import React, { useEffect, useState, useCallback } from "react";
import { View } from "react-native";
import { useHistory, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getPlayerMatchMapping } from "../redux/actions/userMatchMappingAction";

import { STORE_MATCH_STRING } from "../redux/actions/types";
import {
  SetVideoControl,
  UpdateVideoTime,
  SeekVideoTo,
  ClearSeekFlag,
  FetchMatchStringFromServer,
} from "../redux/actions/controlAction";
import InputBoard from "./InputBoard";
import InputBoardNew from "./InputBoardNew";
import InputBoardNewEvents from "./InputBoardNewEvents";
import { useAbly } from "ably/react";
import { subscribeToMatchChannel, unsubscribeFromMatchChannel } from "../utils/ablyManager";

const Analyse = (props) => {
  const [selectedMatchData, setSelectedMatchData] = useState(false);
  const [analysisData, setAnalysisData] = useState(false);
  const [systemType, setSystemType] = useState(1);
  const { matchId } = useParams();
  let history = useHistory();
  const {
    videoControl,
    videoTime,
    SetVideoControl,
    SeekVideoTo,
    ClearSeekFlag,
    analystId,
    token,
    analysedString,
  } = props;

useEffect(() => {
  if (!matchId) return;

  subscribeToMatchChannel(matchId, (msg) => {
    if (msg.name === "match-string-updated") {
      console.log("Match updated → refreshing Analyse");
      props.FetchMatchStringFromServer(matchId, analystId, token);
    }
  });

  return () => {
    unsubscribeFromMatchChannel(matchId);
  };
}, [matchId, analystId, token]);

  const initialHandleUserKeyPress = useCallback(
    (event) => {
      const { key, keyCode } = event;

      if (keyCode === 32) {
        SetVideoControl(!videoControl);
      }
      if (keyCode === 39) {
        SeekVideoTo(parseFloat(videoTime + 5));
      }
      if (keyCode === 37) {
        SeekVideoTo(parseFloat(videoTime - 5));
      }
    },
    [SeekVideoTo, SetVideoControl, videoControl, videoTime]
  );

  useEffect(() => {
    window.addEventListener("keydown", initialHandleUserKeyPress);
    window.addEventListener("keyup", (e) => ClearSeekFlag());
    return () => {
      window.removeEventListener("keydown", initialHandleUserKeyPress);
      window.removeEventListener("keyup", (e) => ClearSeekFlag());
    };
  }, [ClearSeekFlag, initialHandleUserKeyPress]);

  useEffect(() => {
    if (matchId && analystId && token) {
      props.FetchMatchStringFromServer(matchId, analystId, token);
    }
  }, [matchId, analystId, token, props.FetchMatchStringFromServer]);

  useEffect(() => {
    if (!props.isAuthenticated) {
      history.push("/login");
    }
  }, [history, props.isAuthenticated]);

  useEffect(() => {
    if (matchId && props.all_matches) {
      let allMatches = props.all_matches;
      let matchData = allMatches.find((i) => {
        return i.id.toString() === matchId;
      });

      setSelectedMatchData(matchData);
      if (matchData?.is_new_coordinate_system) {
        setSystemType(2);
      } else {
        setSystemType(matchData?.analysis_setup);
      }

      props.GetPlayerMatchMapping(
        matchId,
        matchData?.team_a_details?.id,
        matchData?.team_b_details?.id
      );
    } else {
      history.replace("/");
    }
  }, [props.all_matches, matchId, props.all_matches, history]);

  useEffect(() => {
    if (selectedMatchData && props.team_a_data && props.team_b_data) {
      const analysedata = {
        TeamInput: [
          {
            team_id: selectedMatchData.team_a_details.id,
            team_details: props.team_a_data,
          },
          {
            team_id: selectedMatchData.team_b_details.id,
            team_details: props.team_b_data,
          },
        ],
      };
      setAnalysisData(analysedata);
      console.log(analysedata, "CHHH");
    }
  }, [selectedMatchData, props.team_a_data, props.team_b_data]);

  // const storeMatchStringAndRedirect = (matchString) => {
  //   props.SaveMatchString(matchString);
  //   history.push(`/analyse-preview/${matchId}`);
  // };

  return (
    <div style={styles.container}>
      {analysisData &&
        (systemType === 3 ? (
          <InputBoardNewEvents
            // storeMatchString={storeMatchStringAndRedirect}
            analysedata={analysisData}
          />
        ) : systemType === 2 ? (
          <InputBoardNew
            // storeMatchString={storeMatchStringAndRedirect}
            analysedata={analysisData}
          />
        ) : (
          <InputBoard
            // storeMatchString={storeMatchStringAndRedirect}
            analysedata={analysisData}
          />
        ))}
    </div>
  );
};

const styles = {
  container: {
    flex: 1,
    width: "100%",
    alignItems: "center",
  },
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    login_error: state.auth.login_error,
    loading: state.auth.loading,
    m_error_msg: state.match.m_error_msg,
    analystId: state.auth.analyst_id,
    all_matches: state.match.all_matches,
    team_a_data: state.userMatchMapping.team_a_mapping,
    team_b_data: state.userMatchMapping.team_b_mapping,
    team_a_mapping_error: state.userMatchMapping.team_a_mapping_error,
    team_b_mapping_error: state.userMatchMapping.team_b_mapping_error,
    videoControl: state.control.videoControl,
    videoTime: state.control.videoTime,
    token: state.auth.token,
    analysedString: state.control.analysedString,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ClearSeekFlag: () => {
      dispatch(ClearSeekFlag());
    },
    SeekVideoTo: (t) => {
      dispatch(SeekVideoTo(t));
    },
    UpdateVideoTime: (t) => {
      dispatch(UpdateVideoTime(t));
    },
    SetVideoControl: (c) => {
      dispatch(SetVideoControl(c));
    },
    GetPlayerMatchMapping: (matchId, teamAId, teamBId, token) => {
      dispatch(getPlayerMatchMapping(matchId, teamAId, teamBId, token));
    },
    FetchMatchStringFromServer: (matchId, analystId, token) => {
      dispatch(FetchMatchStringFromServer(matchId, analystId, token));
    },

    SaveMatchString: (match_string) => {
      dispatch({
        type: STORE_MATCH_STRING,
        payload: match_string,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Analyse);
